import {
    REQUEST_PRACTITIONERS,
    LOADED_PRACTITIONERS,
    SEARCH_REQUEST_PRACTITIONERS,
    REQUEST_PROFIL_PRACTITIONER,
    REQUEST_TRANSACTIONS_PRACTITIONER,
    SEARCH_TRANSACTION_PRACTITIONERS,
    REQUEST_FILES_PRACTITIONER,
    ADD_FILE_PRACTITIONER,
    LOADED_SIGNATURE_PRACTITIONER,
    LOADED_CNI_PRACTITIONER,
    LOADED_FILES_PRACTITIONER,
    UPDATE_PRACTITIONER,
    UPDATED_PRACTITIONER,
    SYNCHRONISE_PRACTITIONER,
    SYNCHRONISED_PRACTITIONER,
    REQUEST_PROFIL_PLATFORM_PRACTITIONER,
} from '../actions/practitioners.action'

const initialStates = {
    fetching: false,
    searching: false,
    loading: false,
    data: []
};

export default function practitioners(state = initialStates, action) {
    const { payload, type } = action;
    switch (type) {
        case REQUEST_PRACTITIONERS:
            return { ...state, data: [], fetching: true };
        case SEARCH_REQUEST_PRACTITIONERS:
            return { ...state, searching: true };

        case REQUEST_PROFIL_PRACTITIONER:
            return { ...state, data: [], fetching: true };

        case REQUEST_TRANSACTIONS_PRACTITIONER:
            return { ...state, data: [], fetching:true };
        case SEARCH_TRANSACTION_PRACTITIONERS:
            return { ...state, searching: true };

        case REQUEST_FILES_PRACTITIONER:
            return { ...state, fetching: true };
        case ADD_FILE_PRACTITIONER:
            return { ...state, fetching: true };

        case LOADED_SIGNATURE_PRACTITIONER:
            return { ...state, signature: payload, fetching: false };

        case LOADED_CNI_PRACTITIONER:
            return { ...state, cni: payload, fetching: false };

        case LOADED_FILES_PRACTITIONER:
            return { ...state, signature: payload.signature, cni:payload.cni, fetching: false };

        case LOADED_PRACTITIONERS:
            return { ...state, data: payload, searching: false, fetching: false };

        case UPDATE_PRACTITIONER:
            return { ...state, loading: true };
        case UPDATED_PRACTITIONER:
            return { ...state, loading: false };

        case SYNCHRONISE_PRACTITIONER:
            return { ...state, loading: true };
        case SYNCHRONISED_PRACTITIONER:
            return { ...state, loading: false };

        case REQUEST_PROFIL_PLATFORM_PRACTITIONER:
            return { ...state, data: [] ,fetching: true };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/practitioners.reducer.js